import React from 'react';
import { Layer, ProjectState } from "../shared";
import ImageLayer from './Layers/ImageLayer';
import TextLayer from './Layers/TextLayer';
import VideoLayer from './Layers/VideoLayer';
import AudioLayer from './Layers/AudioLayer';

export const LayerComponents = {
    text: TextLayer,
    image: ImageLayer,
    video: VideoLayer,
    audio: AudioLayer
}

type Props = { 
    layer: Layer,
    project: ProjectState,
};

function LayerContainer({ layer, project }: Props) {
    const LayerComponent = LayerComponents[layer.type];
    return (
        <LayerComponent 
            layer={layer} 
            project={project}
        />
    )
}

export default LayerContainer;
